import { useState, useEffect } from "react"
import { useRouter } from "next/router"

import { getPageData } from "services/craft/craft"
import runMiddleware from "lib/runMiddleware"

import { useConferenceFacultyProfile } from "services/emma/emma"

import Layout from "components/layout/layout"
import Wrapper from "components/layout/wrapper"
import FacultyProfile from "components/faculty/facultyProfile"
import LoadingIndicator from "components/ui/LoadingIndicator"

export default function FacultyProfilePage({ facultyId, site, layoutVariant }) {
    const router = useRouter()
    const [title, setTitle] = useState("")

    const { status, data } = useConferenceFacultyProfile(site.meeting.emmaMeetingId, facultyId)

    useEffect(() => {
        if (status !== "success") return

        // 404
        if (!data || data.success === false) {
            router.push("/404")
            return
        }

        // do not display a page for faculty with these roles
        if (["Abstract Presenter", "Challenging Case Presenter", "Satellite Presenter"].includes(data.role)) {
            router.push("/404")
            return
        }

        setTitle(data.full_name)
    }, [data, router, status])

    return (
        <Layout
            className="facultyProfile__page"
            site={site}
            page={{ title: title + " (faculty) | " + site.meeting.meetingName }}
            slug="program-at-a-glance"
            label="Faculty"
            useLegacyContent={false}
            layoutVariant={layoutVariant}
        >
            <Wrapper>{title ? <FacultyProfile profile={data} /> : <LoadingIndicator />}</Wrapper>
        </Layout>
    )
}

export const getServerSideProps = runMiddleware(async function ({ req, res, params, locale, user }) {
    res.setHeader("Cache-Control", "public, s-maxage=1, stale-while-revalidate=59")

    // extract the faculty id from the slug (ex: ziad-ali-4119)
    const facultyId = /[^-]*$/.exec(params.slug)[0]

    const data = await getPageData({ locale: locale })

    if (!data.site?.meeting?.enableFacultyProfileLinks) {
        return {
            redirect: {
                destination: "/faculty",
                permanent: false,
            },
        }
    }

    return {
        props: {
            // will be passed to the page component as props
            facultyId: facultyId,
            site: data.site,
            locale: locale,
            user: user,
        },
    }
})
